export interface FATOverview {
  agent_name: string;
  agent_id: string;
  zone_code: string;
  fdt_code: string;
  fat_code: string;
  subscribers: string;
  active_subscribers: string;
  expired_subscribers: string;
  connected_sessions: string;
  readings_count: string;
  min_power: string | null;
  max_power: string | null;
  output_power: string | null;
  normal_count: string;
  abnormal_count: string;
  high_count: string;
  down_count: string;
  scannable_count: number;
  updated_at: string | number;
  diagnosis: 'normal' | 'critical';
  last_scan_started_at: string | null;
  last_scan_finished_at: string | null;
  last_scan_status: string;
  last_scan_error: string | null;
  last_scan_scanned: number;
  last_scan_down: number;
  last_scan_offline: number;
  last_scan_failed: number;
}

export interface SubscriberPower {
  agent_name: string;
  agent_id: string;
  subscription_id: string;
  customer_id: string;
  customer_name: string;
  zone_code: string;
  fdt_code: string;
  fat_code: string;
  username: string;
  status: string;
  expires_at: string;
  optical_rx_power: string;
  power_state: 'up' | 'critical' | 'down' | 'offline';
  has_active_session: boolean;
  updated_at: string;
}

const mockFats: FATOverview[] = [
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0028",
    fdt_code: "FNS28",
    fat_code: "FAT1",
    subscribers: "12",
    active_subscribers: "10",
    expired_subscribers: "2",
    connected_sessions: "9",
    readings_count: "10",
    min_power: "-31.40",
    max_power: "-19.10",
    output_power: "-19.10",
    normal_count: "9",
    abnormal_count: "1",
    high_count: "0",
    down_count: "0",
    scannable_count: 10,
    updated_at: new Date().toISOString(),
    diagnosis: "normal",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 10,
    last_scan_down: 0,
    last_scan_offline: 2,
    last_scan_failed: 0
  },
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0028",
    fdt_code: "FNS28",
    fat_code: "FAT2",
    subscribers: "10",
    active_subscribers: "9",
    expired_subscribers: "1",
    connected_sessions: "8",
    readings_count: "9",
    min_power: "-24.20",
    max_power: "-18.50",
    output_power: "-18.50",
    normal_count: "9",
    abnormal_count: "0",
    high_count: "0",
    down_count: "0",
    scannable_count: 9,
    updated_at: new Date().toISOString(),
    diagnosis: "normal",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 9,
    last_scan_down: 0,
    last_scan_offline: 1,
    last_scan_failed: 0
  },
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0029",
    fdt_code: "FNS29",
    fat_code: "FAT1",
    subscribers: "15",
    active_subscribers: "14",
    expired_subscribers: "1",
    connected_sessions: "11",
    readings_count: "13",
    min_power: "-33.80",
    max_power: "-20.15",
    output_power: "-20.15",
    normal_count: "11",
    abnormal_count: "2",
    high_count: "0",
    down_count: "1",
    scannable_count: 14,
    updated_at: new Date().toISOString(),
    diagnosis: "critical",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 14,
    last_scan_down: 1,
    last_scan_offline: 1,
    last_scan_failed: 0
  },
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0029",
    fdt_code: "FNS29",
    fat_code: "FAT2",
    subscribers: "8",
    active_subscribers: "8",
    expired_subscribers: "0",
    connected_sessions: "7",
    readings_count: "7",
    min_power: "-32.10",
    max_power: "-21.30",
    output_power: "-21.30",
    normal_count: "6",
    abnormal_count: "1",
    high_count: "0",
    down_count: "1",
    scannable_count: 8,
    updated_at: new Date().toISOString(),
    diagnosis: "critical",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 8,
    last_scan_down: 1,
    last_scan_offline: 0,
    last_scan_failed: 0
  },
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0029",
    fdt_code: "FNS29",
    fat_code: "FAT3",
    subscribers: "14",
    active_subscribers: "12",
    expired_subscribers: "2",
    connected_sessions: "11",
    readings_count: "12",
    min_power: "-25.60",
    max_power: "-19.40",
    output_power: "-19.40",
    normal_count: "12",
    abnormal_count: "0",
    high_count: "0",
    down_count: "0",
    scannable_count: 12,
    updated_at: new Date().toISOString(),
    diagnosis: "normal",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 12,
    last_scan_down: 0,
    last_scan_offline: 2,
    last_scan_failed: 0
  },
  {
    agent_name: "علي شهيد سعدون فيصل",
    agent_id: "5922",
    zone_code: "FNS0030",
    fdt_code: "FNS30",
    fat_code: "FAT1",
    subscribers: "9",
    active_subscribers: "7",
    expired_subscribers: "2",
    connected_sessions: "5",
    readings_count: "6",
    min_power: "-34.50",
    max_power: "-22.10",
    output_power: "-22.10",
    normal_count: "4",
    abnormal_count: "2",
    high_count: "0",
    down_count: "1",
    scannable_count: 7,
    updated_at: new Date().toISOString(),
    diagnosis: "critical",
    last_scan_started_at: new Date(Date.now() - 3600000).toISOString(),
    last_scan_finished_at: new Date(Date.now() - 3550000).toISOString(),
    last_scan_status: "completed",
    last_scan_error: null,
    last_scan_scanned: 7,
    last_scan_down: 1,
    last_scan_offline: 2,
    last_scan_failed: 0
  }
];

const customerNames = [
  'محمد ضيول فرعون دويخ العساكره',
  'زين العابدين علي راضي موشي الحجامي',
  'عبداللطيف عبد جاسم قطن الموسوي',
  'سلوان توفيق علي سلوان اليدراوي',
  'حيدر علي حسين الموسوي',
  'أحمد جاسم كريم البصري',
  'مصطفى كمال الدين البغدادي',
  'كرار صادق جعفر النجفي',
  'علي شهيد سعدون الكعبي',
  'عمر فاروق فاضل الحمداني',
  'حسين علي جاسم العبيدي',
  'سارة محمد ضياء المالكي',
  'جاسم محمد الشمري',
  'فاطمة حسن الخفاجي',
  'علي حسين كاظم البهادلي',
  'رضا كمال صادق الدوري',
  'ياسر عمار عباس الدليمي',
  'مريم كاظم جواد الزبيدي'
];

const generateMockSubscribers = (): SubscriberPower[] => {
  const list: SubscriberPower[] = [];
  let subIdCounter = 6958600;

  mockFats.forEach(fat => {
    const total = parseInt(fat.subscribers);
    const activeCount = parseInt(fat.active_subscribers);
    const normalCount = parseInt(fat.normal_count);
    const abnormalCount = parseInt(fat.abnormal_count);
    const downCount = parseInt(fat.down_count);

    let nAdded = 0;
    let abAdded = 0;
    let dAdded = 0;

    for (let i = 0; i < total; i++) {
      subIdCounter++;
      const isActive = i < activeCount;
      const customerName = customerNames[subIdCounter % customerNames.length] + ` (#${subIdCounter % 50 + 1})`;
      const username = `fa${fat.fdt_code.replace('FNS', '')}p${subIdCounter}`;

      let powerStr = "Offline";
      let powerState: 'up' | 'critical' | 'down' | 'offline' = "offline";
      let hasSession = false;

      if (isActive) {
        if (nAdded < normalCount) {
          nAdded++;
          const rxVal = (-19.0 - (i * 0.7)).toFixed(2);
          powerStr = `${rxVal}`;
          powerState = "up";
          hasSession = true;
        } else if (abAdded < abnormalCount) {
          abAdded++;
          const rxVal = (-30.5 - (i * 0.8)).toFixed(2);
          powerStr = `${rxVal}`;
          powerState = "critical";
          hasSession = true;
        } else {
          dAdded++;
          powerStr = "Offline";
          powerState = "down";
          hasSession = false;
        }
      }

      list.push({
        agent_name: fat.agent_name,
        agent_id: fat.agent_id,
        subscription_id: String(subIdCounter),
        customer_id: String(2056000 + subIdCounter % 1000),
        customer_name: customerName,
        zone_code: fat.zone_code,
        fdt_code: fat.fdt_code,
        fat_code: fat.fat_code,
        username,
        status: isActive ? "Active" : "Expired",
        expires_at: isActive ? "2026-08-30T00:00:00.000Z" : "2026-06-15T00:00:00.000Z",
        optical_rx_power: powerStr,
        power_state: powerState,
        has_active_session: hasSession,
        updated_at: new Date().toISOString()
      });
    }
  });

  return list;
};

const mockSubscribers = generateMockSubscribers();

export const getMockPowerOverview = () => {
  return { items: mockFats };
};

export const getMockPowerSubscribers = () => {
  return { items: mockSubscribers };
};
